// app/javascript/controllers/modal_controller.js
import { Controller } from "@hotwired/stimulus"
import { stimulus } from "../init"

export default class Tabs extends Controller {
  static targets = ["link", "panel"]

  connect() {
    console.log("Qwerty");
    console.log("Tabs controller connected");
    console.log("Link targets:", this.linkTargets);
    console.log("Panel targets:", this.panelTargets);

    this.selectInitialTab()
    window.addEventListener("hashchange", this.handleHashChange.bind(this))
  }

  disconnect() {
    window.removeEventListener("hashchange", this.handleHashChange.bind(this))
  }

  select(event) {
    if (event) event.preventDefault()

    const selectedLink = event ? event.currentTarget : this.linkTargets.find(link => link.classList.contains("tabs__link-active"))
    if (!selectedLink) return

    const panelId = selectedLink.getAttribute("href").replace("#", "")

    // Update links
    this.linkTargets.forEach(link => {
      const isActive = link === selectedLink
      link.classList.toggle("tabs__link-active", isActive)
      link.setAttribute("aria-selected", isActive ? "true" : "false")
    })

    // Update panels
    this.panelTargets.forEach(panel => {
      const isVisible = panel.id === panelId
      panel.classList.toggle("tabs__panel-active", isVisible)
      panel.style.display = isVisible ? "block" : "none" // For no-CSS fallback
    })

    // Optionally update hash for deep linking
    if (panelId) {
      window.location.hash = panelId
    }
  }

  selectInitialTab() {
    const hash = window.location.hash.replace("#", "")
    let initialLink = this.linkTargets.find(link => link.getAttribute("href") === `#${hash}`)

    if (!initialLink) {
      initialLink = this.linkTargets.find(link => link.classList.contains("tabs__link-active")) || this.linkTargets[0]
    }

    if (initialLink) {
      this.select({ currentTarget: initialLink })
    }
  }

  handleHashChange() {
    this.selectInitialTab()
  }
}

stimulus.register('tabs', Tabs)